import { apiSlice } from '..';
import { ProgramFacultyRatingRequest, UpsertProgramFacultyRatingResponse } from '../generated';

const facultyMutationsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        upsertFacultyRating: builder.mutation<UpsertProgramFacultyRatingResponse, { programSk: number, facultySk: number } & ProgramFacultyRatingRequest>({
            query: ({ programSk, facultySk, ...body }) => ({
                url: `/programs-faculties-ratings/program/${programSk}/faculties/${facultySk}/ratings`,
                method: 'POST',
                body,
            }),
        }),
    })
});

export const { useUpsertFacultyRatingMutation } = facultyMutationsSlice;
export default facultyMutationsSlice;